import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Setup Path Points Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> This is the first step in MTO (Multi-modal Transport Optimization). Set up location points and configure basic parameters for your transport network.</p>
          
          <p><strong>Three Ways to Add Points:</strong></p>
          
          <p><strong>Method 1: Map Point Marking</strong></p>
          <ol>
            <li>Click "Map Point Marking" tab (default mode)</li>
            <li>Click on the map where you want to add a location point</li>
            <li>Point will be automatically numbered and added</li>
            <li>Continue clicking to add more points</li>
          </ol>

          <p><strong>Method 2: Manual Input</strong></p>
          <ol>
            <li>Click "Manual Input" tab</li>
            <li>Enter latitude and longitude coordinates</li>
            <li>Click "Add" button to create the point</li>
            <li>Useful for precise coordinate placement</li>
          </ol>

          <p><strong>Method 3: Load Points (Import File)</strong></p>
          <ol>
            <li>Click "Load Points" button</li>
            <li>Select a CSV or GeoJSON file</li>
            <li>System automatically imports and validates all points</li>
            <li>Best for loading existing configurations</li>
          </ol>

          <p><strong>Configure Start/End Points:</strong></p>
          <ul>
            <li>Click "S" button next to a point to set as start point (origin/depot)</li>
            <li>Click "E" button next to a point to set as end point (destination)</li>
            <li>Start and end points must be different locations</li>
            <li>Both are required before proceeding to routing</li>
          </ul>

          <p><strong>Manage Location Points:</strong></p>
          <ul>
            <li>View all added points in the Location Points list</li>
            <li>Edit point names by clicking on them</li>
            <li>Delete unnecessary points using × button</li>
            <li>Export configuration using dropdown menu (CSV/GeoJSON)</li>
            <li>Reset to clear all points and start over</li>
          </ul>

          <p><strong>Complete MTO Workflow:</strong></p>
          <ol>
            <li><strong>Step 1: Setup Mode (Current)</strong>
              <ul>
                <li>Add all location points for your transport network</li>
                <li>Set start point (origin/depot) and end point (destination)</li>
                <li>Export configuration for backup</li>
              </ul>
            </li>
            <li><strong>Step 2: Connection Mode</strong>
              <ul>
                <li>Create connections between location points</li>
                <li>Set transport modes (Bike/Truck/Train/Ship) and durations</li>
                <li>Configure transport demand and capacity constraints</li>
              </ul>
            </li>
            <li><strong>Step 3a: Auto Find Path Mode</strong>
              <ul>
                <li>Use algorithms to automatically find optimal routes</li>
                <li>Compare different algorithm results</li>
              </ul>
            </li>
            <li><strong>Step 3b: Custom Path Mode</strong>
              <ul>
                <li>Manually design your own routes</li>
                <li>Apply domain expertise and constraints</li>
              </ul>
            </li>
            <li><strong>Step 4: Comparison Mode</strong>
              <ul>
                <li>Compare auto-generated vs manual routes</li>
                <li>Analyze efficiency and identify improvements</li>
              </ul>
            </li>
          </ol>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Minimum 2 points required, but add all necessary locations first</li>
            <li>Use descriptive names for points (e.g., "Warehouse A", "Port B")</li>
            <li>Start and end points must be different locations</li>
            <li>Save your configuration regularly using Export</li>
            <li>You can import existing configurations to save time</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 